/* eslint-disable no-nested-ternary */
export const createOptions = (startPosition, endPosition) => {
  let options = {};
  let endSocket;
  if (endPosition) {
    endSocket = endPosition.indexOf('bottom') >= 0 ? 'bottom'
      : endPosition.indexOf('right') >= 0 ? 'right'
        : endPosition.indexOf('left') >= 0 ? 'left'
          : endPosition.indexOf('top') >= 0 ? 'top' : '';
  }
  if (startPosition.indexOf('bottom') >= 0) {
    options = { startSocket: 'bottom', endSocket: endSocket || 'top' };
  } else if (startPosition.indexOf('top') >= 0) {
    options = { startSocket: 'top', endSocket: endSocket || 'bottom' };
  } else if (startPosition.indexOf('left') >= 0) {
    options = { startSocket: 'left', endSocket: endSocket || 'right' };
  } else if (startPosition.indexOf('right') >= 0) {
    options = { startSocket: 'right', endSocket: endSocket || 'left' };
  }
  return options;
};
